import React from "react";
import { Link } from 'react-router-dom';

const OurCampus = () => {
  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: 'url("/img/banner/banner-our-campus.jpg")' }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Our Campus</h1>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li>Our Campus</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-style01">
        <div className="container">
          <div className="row align-items-xl-center mt-n1-9">
            <div className="col-lg-6 mt-1-9 order-2 order-lg-1">
              <div className="pe-lg-2-2 top-right-content">
                <div
                  className="section-title01 mb-1-9 pe-xl-6 pe-xxl-10 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h2 className="mb-0 display-4 font-weight-800 lh-1 ls-minus-2px">
                    Campus Overview
                  </h2>
                </div>
                <p
                  className="w-xl-100 mb-1-9 wow fadeInUp"
                  data-wow-delay="150ms"
                >
                  Nestled along the banks of the Shali Rivulet in Bankura, the
                  Shamayita Math campus is a sprawling, lush, and verdant
                  expanse. The serene surroundings, with paddy fields and hills
                  showcasing the six seasons of rural Bengal, enhance its
                  natural beauty. Infused with the divine essence of Sri Sri
                  Prabhuji, the campus radiates a profound spirituality that
                  permeates every corner.
                </p>
              </div>
            </div>
            <div
              className="col-lg-6 mt-1-9 order-1 order-lg-2 wow fadeInUp"
              data-wow-delay="300ms"
            >
              <div className="image-hover">
                <img
                  src="img/content/oc-1.jpg"
                  alt="Campus Overview"
                  className="border-radius-10"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Special Areas of Interest */}
      <section className="bg-secondary mx-xxl-1-9 border-radius-10">
        <div className="container">
          <div
            className="section-title01 mb-2-9 text-center wow fadeInUp"
            data-wow-delay="100ms"
          >
            <span>Special Areas of Interest</span>
            <h2 className="mb-0 font-weight-700 lh-sm text-white w-md-90 w-lg-90 w-xl-90 mx-auto">
              Within the Shamayita Math campus, several noteworthy spaces
              provide distinct experiences with most contributing to its overall
              spiritual ambience.
            </h2>
          </div>
        </div>
      </section>

      {/* Blog Grid Two Columns */}
      <section>
        <div className="container">
          <div className="row align-items-xl-center mt-n1-9">
            <div className="col-lg-12 mt-1-9 order-2 order-lg-1">
              <div className="pe-lg-2-2 top-right-content">
                <div
                  className="section-title01 mb-1-9 pe-xl-6 pe-xxl-10 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h2 className="mb-2 display-4 font-weight-800 lh-1 ls-minus-2px">
                    Our Campus
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-n1-9">
            {[
              {
                title: "Shivohom Mancha - A Place of Truth",
                desc: "It is a platform where devotees gather to explore and realize the absolute truth that exists within each one of us. This serene environment provides a perfect setting for those seeking self-discovery.",
                image: "img/content/oc-2.jpg",
                tag: "Shivohom Mancha",
              },
              {
                title: "Communion Hall - Connecting with the Absolute",
                desc: "An auditorium where ideas and thoughts are exchanged, and a space for individuals to seek communion with the Almighty. Equipped with a high-quality sound system, this hall serves as a venue for evening prayers and meditations, as well as seminars, workshops, and cultural events.",
                image: "img/content/oc-3.jpg",
                tag: "Communion Hall",
              },
              {
                title: "Samani Bhavan - Guest Accommodation",
                desc: "A guest house for the comfortable stay of those associated with the activities of Shamayita Math including experts, donors, well-wishers, and followers. It offers deluxe suites, AC, and non-AC twin-bedded rooms, as well as non-AC dormitories.",
                image: "img/content/oc-4.jpg",
                tag: "Samani Bhavan",
              },
              {
                title: "Conference Hall - Meetings and Interactive Sessions",
                desc: "The conference hall is furnished with air conditioning, a sound system, and audiovisual facilities and serves as a venue for meetings, interactive sessions, and various discussions.",
                image: "img/content/oc-5.jpg",
                tag: "Conference Hall",
              },
              {
                title: "Library - A Hub of Knowledge",
                desc: "The conference hall hosts a library that houses a diverse collection of books and magazines, offering a wealth of knowledge to the Shamayita Math community and visitors.",
                image: "img/content/oc-6.jpg",
                tag: "Library",
              },
              {
                title: "Prayer Hall - Spiritual Gatherings",
                desc: "The Math's residents gather here for regular morning and evening prayers, followed by meditation. Additionally, spiritual discourses for women followers are held twice a month.",
                image: "img/content/oc-7.jpg",
                tag: "Prayer Hall",
              },
              {
                title: "Annam Bhavan - Dining Hall",
                desc: "A dining hall where around 100 people, including staff, guests, and followers are served vegetarian meals every day",
                image: "img/content/oc-8.jpg",
                tag: "Annam Bhavan",
              },
              {
                title: "Shamayita Krirangan - Sports Academy",
                desc: "Empowering rural youth through professional football training, structured coaching, and competitive exposure to excel at state and national levels.",
                image: "img/content/oc-9.jpg",
                tag: "Shamayita Krirangan",
              },
              {
                title: "Green Orchard - Practical Learning Hubs",
                desc: "An LIC model for farmers—Live orchards that Inspire confidence and build Capability through hands-on learning.",
                image: "img/content/oc-10.jpg",
                tag: "Green Orchard",
              },
              {
                title: "Krishani - Community Farming Outlet",
                desc: "Bringing nature-positive produce like aromatic rice, spices, and dry fruits directly from rural farms to people.",
                image: "img/content/oc-11.jpg",
                tag: "Krishani",
              },

            ].map((item, i) => (
              <div
                key={i}
                className="col-sm-6 mt-1-9 wow fadeInUp"
                data-wow-delay={`${100 + (i % 2) * 100}ms`}
              >
                <article className="card card-style04 rounded h-100">
                  <div className="blog-img position-relative overflow-hidden image-hover">
                    <img
                      src={item.image}
                      alt={item.tag}
                      className="rounded-top"
                    />
                    <span>
                      <a href="#">{item.tag}</a>
                    </span>
                  </div>
                  <div className="card-body p-1-6 p-lg-2-3">
                    <h4 className="mb-3">{item.title}</h4>
                    <p className="mb-3">{item.desc}</p>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
};

export default OurCampus;
